<div class="loader">
  <div class="loader__icon"></div>
</div>
